export const FOLDER_ORGANIZATIONS_EUDR_DOCUMENTS = 'organizations-eudr';
export const FOLDER_PROCESS_MAP_EUDR_DOCUMENTS = 'process-map-eudr';
